"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageTranspose = void 0;

var _RgbaImageBuffer = _interopRequireDefault(require("../RgbaImageBuffer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Applies image transpose operation to the given image.
 *
 * @param {RgbaImageBuffer} imgBuffer Image to transform
 * @returns {RgbaImageBuffer} Transformed image
 */


var imageTranspose = function imageTranspose(imgBuffer) {
  var height = imgBuffer.width;
  var width = imgBuffer.height;
  var resultPixels = new Uint8ClampedArray(width * height * _RgbaImageBuffer.default.NUM_CHANNELS);
  var currentIndex = 0;
  var originalImagePixel;

  for (var j = 0; j < height; ++j) {
    for (var i = 0; i < width; ++i) {
      originalImagePixel = imgBuffer.getPixel({
        x: j,
        y: i
      });
      resultPixels[currentIndex] = originalImagePixel[0]; // R channel

      resultPixels[currentIndex + 1] = originalImagePixel[1]; // G channel

      resultPixels[currentIndex + 2] = originalImagePixel[2]; // B channel

      resultPixels[currentIndex + 3] = originalImagePixel[3]; // A channel

      currentIndex += _RgbaImageBuffer.default.NUM_CHANNELS;
    }
  }

  return new _RgbaImageBuffer.default(width, height, resultPixels);
};

exports.imageTranspose = imageTranspose;